<template>
  <SogCard class="sog-card-without-title">
    <SogCardContent>
      <table>
        <tr>
          <td>
            <SogDataLabel
              v-show="memo"
              :value="memo"
            />
            <SogDataLabel
              v-show="!memo"
              value="keine Bemerkung vorhanden"
            />
          </td>
        </tr>
      </table>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  memo?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    memo: undefined
  }
)

</script>


<style scoped>

</style>
